import './CountryFilter.css'

import { SearchOutlined } from '@ant-design/icons'
import React, { useEffect, useState } from 'react'
import Flag from 'react-world-flags'
import NoCountries from '../assets/NoCountries.svg'
import CountryFilterFlags from '../assets/filter-by-country.png'
import IconOperators from '../assets/IconOperators.svg'
import Close from '../assets/Close.svg'
import Cross from '../assets/Cross.svg'
import SearchIcon from '../assets/SearchGlass.svg'
import newLabel from '../assets/newLabel.svg'
import localhostSettings from '../local'
import { useTranslation } from 'react-i18next'
import useCountryStore from '../store/useCountryStore'
import FilterCountries from '../FilterCountries'
import { READMORE } from '../constants'
import { useHits } from 'react-instantsearch'

interface CountryFilterProps {
  selectedCountries: string[]
  setSelectedCountries: (countries: string[]) => void
}

const CountryFilter: React.FC<CountryFilterProps> = ({
  selectedCountries,
  setSelectedCountries,
}) => {
  const { data, fetchData }: any = useCountryStore();
  const { hits } =  useHits()


  const dataSet = data?.getCategoryByID?.metaExtension?.dataSet || [];
  const roamingEntry = dataSet.find(
    (item: any) => item?.genericData?.valueSet?.roamingcountries
  );

  const { t } = useTranslation()

  const isRTL = localhostSettings.isRTL()
  const [filteredCountries, setFilteredCountries] = useState<any[]>([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [countryInfoModal, setCountryInfoModal] = useState<any>(
    null
  )
  const [activeTab, setActiveTab] = useState<'operators' | 'payg'>('payg')

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add('modal-open')
    } else {
      document.body.classList.remove('modal-open')
    }
  }, [isModalOpen])
  // Toggle country in modal list
  const toggleCountry = (countryName: string) => {
    if (selectedCountries.includes(countryName)) {
      setSelectedCountries(selectedCountries.filter((c) => c !== countryName))
    } else if (selectedCountries.length < 3) {
      setSelectedCountries([...selectedCountries, countryName])
    }
  }
  const roamingCountries = roamingEntry?.genericData?.valueSet?.roamingcountries
      ?.filter(
        (country: any, index: number, self: any[]) =>
          index === self.findIndex((c: any) => c.countryEnglish === country.countryEnglish)
      ) ?? []


  // Clear all selected countries
  const clearAll = () => {
    setSelectedCountries([])
  }

  const countryBundleCountMap = hits
  .reduce((acc: Record<string, number>, hit: any) => {
    hit.supportedCountryOperator?.forEach((country: any) => {
      if (!country?.countryEnglish) return
      acc[country.countryEnglish] = (acc[country.countryEnglish] || 0) + 1
    })

    return acc
  }, {})

  const getCountryDescription = (countryEnglish: string) => {
    const bundleCount = countryBundleCountMap[countryEnglish] || 0

    return bundleCount > 0
      ? t("bundles_Availble", { bundleCount })
      : t("pay_as_you_go")
  }

  return (
    <>
      <div className="filter-wrapper">
        <div className="filter-page-title">{t('Roaming_services')}</div>

        {/* Selected countries pills */}
        {selectedCountries.length > 0 && (
          <div className="selected-countries-wrapper">
            <span>{t("Showing_matching_bundles_for")}</span>
            <div className="selected-countries-list">
              {selectedCountries.map((engName: any) => {
                const country = roamingCountries.find((country: any) => country.countryEnglish === engName)
                if (!country) return null

                return (
                  <div key={country.countryEnglish} className="country-pill">
                    <Flag
                      code={country.id}
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        marginRight: 6,
                      }}
                    />
                    <span>{isRTL ? country.countryArabic : country.countryEnglish}</span>
                    <button
                      className="info-button"
                      title={`Info about ${isRTL ? country.countryArabic : country.countryEnglish}`}
                      onClick={() => {
                        setCountryInfoModal(country)
                        setActiveTab('payg')
                      }}
                    >
                      i
                    </button>
                  </div>
                )
              })}
            </div>
            <button className="clear-all-button" onClick={clearAll}>
              {t('CLEAR_ALL')}
            </button>
          </div>
        )}

        {selectedCountries.length === 0 && (
          <div className="styled-card">
            <div className="card-content">
              <div className="text-content">
                <div className='new-label'>{t('NEW')}</div>
                <h3 className="filter-title">
                  {t("Filter_bundles_by_country")}
                </h3>
                <p className="filter-subtitle">
                  {t("Filter_your_options_based_on_your_travel_plans")}
                </p>

                <button className="filter-button" onClick={() => setIsModalOpen(true)}>
                  {t('Filter')}
                </button>
              </div>
              <img src={CountryFilterFlags} alt="Icon" className="card-icon" />
            </div>
          </div>
        )}
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
            <div className='x-close-button'>
              <button className="modal-close" onClick={() => setIsModalOpen(false)}>
                <img src={Close} alt='closeButton' />
              </button>
            </div>
          <div className="modal-content">
            
            <div className="modal-header">
              <div className='subtitle-text'>{t("Filter_bundles_by_country")}</div>
              <p>{t("Filter_your_options_based_on_your_travel_plans")}</p>
             
            </div>
            <FilterCountries
              data={roamingCountries}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              onFilter={setFilteredCountries}
            />

            <div className="selected-count-row">
              <span className="selected-count">{selectedCountries.length}/3 {t("selected")}</span>
              {selectedCountries.length > 0 && (
                <button className="clear-all-button" onClick={clearAll}>
                  {t("CLEAR_ALL")}
                </button>
              )}
            </div>

            <div className='country-list'>
              {!searchTerm && (
                <>
                  <div className='Country_Sub_title'>
                    <label className='Search_Result'>{t("All_Countries")}</label>
                  </div>
                  {filteredCountries.map((country: any) => (
                    <label key={country.countryEnglish} className="country-option">
                      <div className="country-left">
                        <Flag
                          code={country.id}
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            marginRight: 6,
                          }}
                        />
                        <div className="country-text">
                          <span className="country-name">{isRTL ? country.countryArabic : country.countryEnglish}</span>
                          <span className="country-description">
                            {getCountryDescription(country.countryEnglish)}
                          </span>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        checked={selectedCountries.includes(country.countryEnglish)}
                        onChange={() => toggleCountry(country.countryEnglish)}
                      />
                    </label>
                  ))}
                </>
              )}
              {searchTerm && filteredCountries.length > 0 && (
                <>
                  <div className='Country_Sub_title'>
                    <label className='Search_Result'>{t("Search_Result")}</label>
                  </div>
                  {filteredCountries.map((country: any) => (
                    <label key={country.countryEnglish} className="country-option">
                      <div className="country-left">
                        <Flag
                          code={country.id}
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            marginRight: 6,
                          }}
                        />
                        <div className="country-text">
                          <span className="country-name">{isRTL ? country.countryArabic : country.countryEnglish}</span>
                          <span className="country-description">
                              {getCountryDescription(country.countryEnglish)}
                          </span>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        checked={selectedCountries.includes(country.countryEnglish)}
                        onChange={() => toggleCountry(country.countryEnglish)}
                      />
                    </label>
                  ))}
                </>
              )}

              {searchTerm && filteredCountries.length === 0 && (
                <>
                  <div className='Country_Sub_title'>
                    <label className='Search_Result'>{t("Most_Visited")}</label>
                  </div>


                  <div className="country-left no-results">
                    <img
                      src={NoCountries}
                      alt="Nocountries"
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        marginRight: 6,
                      }}
                    />
                    <span className="No-countries-found-test">
                      {t("No_countries_found")}
                    </span>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              <div className='Footer-preview'>
                <div className="selected-preview">
                  {selectedCountries.map((engName: any) => {
                    const match = roamingCountries.find((country: any) => country.countryEnglish === engName)
                    if (!match) return null
                    return (
                      <div key={match.countryEnglish} className="preview-pill">
                        <Flag
                          code={match.id}
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            marginRight: 6,
                          }}
                        />
                        <span>{isRTL ? match.countryArabic : match.countryEnglish}</span>
                      </div>
                    )
                  })}

                  {/* Always show count, even if 0 */}
                  <span className="selection-count">{selectedCountries.length}/3 {t("selected")}</span>
                </div>

                <button
                  className="show-options"
                  disabled={selectedCountries.length === 0}
                  onClick={() => setIsModalOpen(false)}
                >
                  {t("Show_Options")}
                </button>
              </div>
            </div>
          </div>
        </div >
      )}

      {
        countryInfoModal && (
          <div className="info-modal-overlay">
            <div className="info-modal-content">
              <div className="info-modal-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Flag
                    code={countryInfoModal.id}
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      marginRight: 6,
                    }}
                  />
                  <div className='subtitle-text'>
                    {' '}
                    {t("Roaming_in", { countryName: isRTL ? countryInfoModal.countryArabic : countryInfoModal.countryEnglish })}
                  </div>
                </div>
                <button className="info-modal-close" onClick={() => setCountryInfoModal(null)}>
                  ✕
                </button>
              </div>

              <div className="info-modal-tabs">
                <button
                  className={`tab ${activeTab === 'operators' ? 'active' : ''}`}
                  onClick={() => setActiveTab('operators')}
                >
                  {t("Operators")}
                </button>
                <button
                  className={`tab ${activeTab === 'payg' ? 'active' : ''}`}
                  onClick={() => setActiveTab('payg')}
                >
                  {t("PAYG_rates")}
                </button>
              </div>

              {activeTab === 'operators' && (
                <div className="operators-section">
                  <h3>{t("Available_operators")}</h3>
                  <p className="description">
                    {t(`You_can_connect_to_any`)}
                  </p>

                  <ul className="operator-list">
                    {countryInfoModal?.operators?.map((op: any) => {
                      return (
                        <li>
                          <span>
                            <img src={IconOperators} className="info-iconOperators" /> {isRTL ? op.operatorArabic : op.operatorEnglish}
                          </span>
                          {/* <span className="preferred">{t("Preferred_operator")}</span> */}
                          <hr className="info-divider"></hr>
                        </li>
                      )
                    })}
                  </ul>

                  <p className="info-terms">
                    {t("T&C_summary")}{' '}
                    <a className="link-readMore" href={READMORE}>
                      {t("Read_more")}
                    </a>
                  </p>
                </div>
              )}

              {activeTab === 'payg' && (
                <div className="payg-section">
                  <h3>{t("Pay_As_You_Go_rates")}</h3>
                  <p className="description">
                    {t(`Roaming_in_this_country`)}
                  </p>

                  <div className="rate-grid">
                    <div className="filter-rate-row">
                      <div className="rate-cell">
                        <strong>{t("Local_calls")}</strong>
                        <span>{t("SAR")}{countryInfoModal?.paygRates?.[0]?.localCall ?? 0} {t("SAR/min")}</span>
                      </div>
                      <div className="rate-cell">
                        <strong>{t("Received_calls")}</strong>
                        <span>{t("SAR")}{countryInfoModal?.paygRates?.[0]?.receivedCalls ?? 0} {t("SAR/min")}</span>
                      </div>
                      <div className="rate-cell">
                        <strong>{t("Calls_to_KSA")}</strong>
                        <span>{t("SAR")}{countryInfoModal?.paygRates?.[0]?.callToKSA ?? 0} {t("SAR/min")}</span>
                      </div>
                    </div>
                    <div className="filter-rate-row">
                      <div className="rate-cell">
                        <strong>{t("International_Calls")}</strong>
                        <span>{t("SAR")}{countryInfoModal?.paygRates?.[0]?.internationalCalls ?? 0} {t("SAR/min")}</span>
                      </div>
                      <div className="rate-cell">
                        <strong>{t("Internet_&_MMS")}</strong>
                        <span>{t("SAR")}{countryInfoModal?.paygRates?.[0]?.internetMMS ?? 0} {t("SAR/MB")}</span>
                      </div>
                      <div className="rate-cell">
                        <strong>{t("Receive_SMS")}</strong>
                        <span>{t(countryInfoModal?.paygRates?.[0]?.receivedSMS ?? '')}</span>
                      </div>
                    </div>
                    <div className="filter-rate-row">
                      <div className="rate-cell">
                        <strong>{t("Send_SMS")}</strong>
                        <span> {t("SAR")}{countryInfoModal?.paygRates?.[0]?.sendSMS ?? ''} </span>
                      </div>
                    </div>
                  </div>

                  <p className="info-terms">
                    {t("T&C_summary")}{' '}
                    <a className="link-readMore" href={READMORE}>
                      {t("Read_more")}
                    </a>
                  </p>
                </div>
              )}
            </div>
          </div>
        )
      }
    </>
  )
}

export default CountryFilter
